export default "__VITE_ASSET__dd049cc8__"